/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { KTSVG } from '../../../_metronic/helpers'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { RequestService } from './components/RequestService'
import { ScreenServices } from './components/ScreenServices'
import useSize from '../../hooks/useSize'
import styles from './storeServices.module.css'

const storeServicesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

type ActiveTab = 'services' | 'newRequest'

const SCREEN_TITLES: Record<string, string> = {
  '1': 'Solicitações de Serviço',
  '2': 'Ordens de Serviço',
  '3': 'Calendário',
  '4': 'Catálogo de Serviços',
}

const StoreServicesPage: FC = () => {
  const [refreshPage, setRefreshPage] = useState<boolean>(false)
  const [activeTab, setActiveTab] = useState<ActiveTab>('services')
  const { page } = useParams()
  const location = useLocation()
  const { width: largura } = useSize()

  useEffect(() => {
    setActiveTab('services')
  }, [page, location.pathname])

  const showServicesTab = activeTab === 'services'
  const showNewRequestTab = activeTab === 'newRequest'
  const screenTitle = SCREEN_TITLES[page ?? ''] ?? SCREEN_TITLES['1']

  return (
    <div
      className='column g-5 g-xl-8 card p-7'
      style={{
        height: '100%',
        minHeight: '60vh',
        paddingBottom: '1rem',
      }}
    >
      <div>
        <div style={{ display: 'flex' }}>
          <ul
            className={`nav nav-stretch nav-line-tabs nav-line-tabs-2x fw-bolder flex-nowrap ${styles.servicesNav} ${
              largura < 1200 ? '' : 'mb-0'
            } fs-${largura < 1200 ? '7' : '5'}`}
            style={{
              display: 'flex',
              height: 'auto',
              width: '100%',
              justifyContent: 'space-between',
            }}
            role='tablist'
          >
            <li className='nav-item' role='presentation'>
              <a
                href='#'
                role='tab'
                aria-selected={showServicesTab}
                className={`nav-link text-active-primary me-6 ${styles.navTab} ${
                  showServicesTab ? 'active' : ''
                }`}
                onClick={(event) => {
                  event.preventDefault()
                  setActiveTab('services')
                }}
              >
                <i className={`bi bi-grid-1x2 ${styles.navTabIcon}`} aria-hidden />
                Serviços
                <i className='bi bi-chevron-right fs-7 text-gray-500 mx-3' aria-hidden />
                <span className={styles.navTabTitle}>{screenTitle}</span>
              </a>
            </li>

            <li className={`nav-item ${styles.navActionItem}`} role='presentation'>
              <button
                type='button'
                role='tab'
                aria-selected={showNewRequestTab}
                className={`btn btn-sm btn-light-primary nav-link ${
                  showNewRequestTab ? 'active' : ''
                }`}
                onClick={() => setActiveTab('newRequest')}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                Nova Solicitação de Serviço
              </button>
            </li>
          </ul>
        </div>

        <div className='tab-content' id='myTabContent'>
          <div
            className={`tab-pane fade ${showServicesTab ? 'active show' : ''}`}
            id='kt_tab_pane_5'
            role='tabpanel'
            aria-hidden={!showServicesTab}
          >
            <ScreenServices
              refreshPage={refreshPage}
              setRefreshPage={setRefreshPage}
            />
          </div>
          <div
            className={`tab-pane fade ${showNewRequestTab ? 'active show' : ''}`}
            id='kt_tab_pane_2'
            role='tabpanel'
            aria-hidden={!showNewRequestTab}
            style={{ height: '100%', minHeight: '60vh' }}
          >
            <RequestService
              refreshPage={refreshPage}
              setRefreshPage={setRefreshPage}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const StoreServicesWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={storeServicesBreadcrumbs}>Gestão de serviços</PageTitle>
      <StoreServicesPage />
    </>
  )
}

export { StoreServicesWrapper }
